var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-table-cell",
      style: { backgroundColor: _vm.backgroundColor },
      attrs: { id: `fine-or-bonus-${_vm.data.fineOrBonusAmountCell.id}` },
    },
    [
      _c("div", { staticClass: "c-table__cell-value" }, [
        _c(
          "svg",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.data.fineOrBonusAmountCell.isFined,
                expression: "data.fineOrBonusAmountCell.isFined",
              },
            ],
            attrs: {
              width: "10",
              height: "12",
              viewBox: "0 0 10 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M5 11V1M5 1L9 5M5 1L1 5",
                stroke: "#FF238D",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
          ]
        ),
        _c("span", [
          _vm._v(
            _vm._s(_vm.prettifyAmount(_vm.data.fineOrBonusAmountCell.amount))
          ),
        ]),
      ]),
      _vm.data.fineOrBonusAmountCell.isFined
        ? _c(
            "b-popover",
            {
              attrs: {
                target: `fine-or-bonus-${_vm.data.fineOrBonusAmountCell.id}`,
                triggers: "hover blur",
                placement: "bottom",
                container: "#app",
                "custom-class": "fine-tooltip",
              },
            },
            [
              _vm._v(
                " Выписан штраф за отсутствие объяснительной в размере 100 ฿ "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }